/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate } from "../../clients/individualPaymentEditorsController/postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/inactivate",
      },
    ] as const;

export type PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationKey
  >;

export function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"];
      params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, params }) => {
      return postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate(
        financialPersonId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Cancela as parcelas abertas (aguardando integração/pendentes) e inativa o plano. Com 'reactivate=true' reabre como pendentes as parcelas renegociadas vinculadas. Migrado do legado IndividualPayment/Inactivate (InactivatePlan). **(Requer Authorization para autenticação)**
 * @summary Inativa o plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/inactivate}
 */
export function usePostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"];
        params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"];
        params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"];
      params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"];
      params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams;
    },
    TContext
  >;
}
